import "core-js/modules/es.function.name.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
import { ref } from 'vue';
import { menusList } from './menusList';
export default {
  setup: function setup(__props) {
    var defaultActive = ref(sessionStorage.getItem('path') || '/userInfo/userInfo');

    var savePath = function savePath(path) {
      sessionStorage.setItem('path', "/".concat(path));
    };

    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_el_menu = _resolveComponent("el-menu");

      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": defaultActive.value,
        class: "menuContainer",
        router: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menusList), function (item) {
            return _openBlock(), _createBlock(_component_el_menu_item, {
              index: item.path,
              key: item.path,
              onClick: function onClick($event) {
                return savePath(item.path);
              }
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_el_icon, null, {
                  default: _withCtx(function () {
                    return [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))];
                  }),
                  _: 2
                }, 1024), _createElementVNode("span", null, _toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["index", "onClick"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["default-active"]);
    };
  }
};